export enum timeHorizonEnum {
  THREE_TO_FIVE_YEARS = 305,
  FIVE_TO_ELEVEN_YEARS = 610,
  ELEVEN_TO_FIFTEEN_YEARS = 1115,
  SIXTEEN_TO_TWENTY_YEARS = 1620,
  TWENTYONE_PLUS_YEARS = 2100
}

export const timeHorizonHelper = (time: number) => {
  if (time < 6) {
    return timeHorizonEnum.THREE_TO_FIVE_YEARS;
  }
  if (time > 5 && time < 11) {
    return timeHorizonEnum.FIVE_TO_ELEVEN_YEARS;
  }
  if (time > 10 && time < 16) {
    return timeHorizonEnum.ELEVEN_TO_FIFTEEN_YEARS;
  }
  if (time > 15 && time < 21) {
    return timeHorizonEnum.SIXTEEN_TO_TWENTY_YEARS;
  }

  return timeHorizonEnum.TWENTYONE_PLUS_YEARS;
};
